import { InputHTMLAttributes } from "react";

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  className?: string;
  value?: string | number;
  defaultValue?: string | number;
  onChange?: (e: any) => void;
  type?: string;
  min?: any;
  name?: string
  required?: boolean
  readOnly?: boolean
  placeholder?: string
  checked?: boolean
  defaultChecked?: boolean;
  disabled?: boolean;
  style?: any
  warning?: { text: string, isVisible: boolean }
  step?: string
  pattern?: string
  deleteField?: () => void
}

export const InputField = ({
  label,
  className,
  value,
  defaultValue,
  onChange,
  type,
  min,
  name,
  required,
  readOnly,
  placeholder,
  checked,
  defaultChecked,
  disabled,
  style,
  warning,
  step,
  pattern,
  deleteField,
  ...props
}: InputFieldProps) => {
  return (
    <div className={`mb-4 w-full relative`}>
      {label && (
        <label className="inline-block text-sm font-base text-gray-300 mb-2 w-5/6 mr-0">
          {label}
        </label>
      )}
      {deleteField && (
        <button onClick={deleteField} className="cursor-pointer text-right inline-block text-sm font-base text-gray-300 mb-2 w-1/6 mr-0">X</button>
      )}
      {
        checked ?
          <input
            {...props}
            type={type}
            onChange={onChange}
            className={`input ${className}`}
            name={name}
            required={required}
            checked={checked}
            defaultChecked={defaultChecked}
            disabled={disabled}
            style={style}
          /> :
          <input
            {...props}
            type={type}
            onChange={onChange}
            defaultValue={defaultValue}
            value={value}
            className={`bg-transparent text-left text-gray-40 placeholder-gray-600 border-2 rounded-lg w-full px-4 py-3 border-kyzzen-secondary ${className} read-only:opacity-50`}
            min={min}
            name={name}
            required={required}
            readOnly={readOnly}
            placeholder={placeholder}
            disabled={disabled}
            style={style}
            step={step}
            pattern={pattern}
          />
      }
      {warning && warning?.isVisible && (
        <label className="block absolute text-sm font-base text-red-700 mb-1">
          {warning.text}
        </label>
      )}
    </div>
  );
};
